import React, { useEffect } from "react";
import CustomSwiper from "../components/Home/CustomSwiper";
import PartsBenefits from "../components/Home/PartsBenefits";
import PromoHydroluz from "../components/Home/PromoHydroluz";
import SwiperBrands from "../components/Home/SwiperBrands";
import LogisticsInfo from "../components/Home/LogisticsInfo";

const HomePage = () => {
  useEffect(() => {
    document.title = "Material Hidrosanitario y Ferretería en Línea | Hydroluz";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <CustomSwiper />
      <SwiperBrands />
      <LogisticsInfo />
      <PartsBenefits />
      <PromoHydroluz />
    </main>
  );
};

export default HomePage;
